import ErrorBoundary from "@/components/ErrorBoundary/Component";

export default ErrorBoundary;
